type TileImage = {
    readonly block: { readonly url: string; readonly title: string | null };
};

export const getTileTitle = (
    page: { tile_title?: string; title?: string } | null | undefined,
    fallback: string,
): string => {
    if (!page) return fallback;
    if (
        "tile_title" in page &&
        typeof page.tile_title === "string" &&
        page.tile_title
    ) {
        return page.tile_title;
    }
    if ("title" in page && typeof page.title === "string" && page.title) {
        return page.title;
    }
    return fallback;
};

export const getTileImage = (
    page: { tile_image?: TileImage | null } | null | undefined,
): TileImage | null => {
    if (page && "tile_image" in page && page.tile_image) {
        return page.tile_image;
    }
    return null;
};
